import type { ReactElement } from 'react';
import type { CouncilMember, PolitickaStrana } from '../../api';
import type { TFunction, i18n as I18nInstance } from 'i18next';
import { capitalizeFirstLetter, formatPercent } from '../../utils/texts';
import { Link } from 'react-router-dom';
import type { UrlParamsUsedForNavigationType } from '../../types';
import { buildCouncilPath } from '../../utils/councilParams';

export function formatMemberNameForComparison(name: string): ReactElement | string {
    if (window.innerWidth < 1200) {
        const nameParts = name.split(' ');
        if (nameParts.length === 3) {
            return (
                <>
                    {nameParts[0]}
                    <br />
                    {nameParts[1][0]}. {nameParts[2]}
                </>
            );
        } else if (name.length > 13) {
            return (
                <>
                    {nameParts[0]}
                    <br />
                    {nameParts[1]}
                </>
            );
        }
    }
    return name;
}

export function formatMemberActivityForComparison(
    isActive: '1' | '0',
    memberData: CouncilMember | null,
    t: TFunction
): string {
    const pohlavi = memberData ? memberData.pohlavi : undefined;

    return Boolean(isActive)
        ? `${(t('comparison.formattingFunctions.activeMember', { ns: 'analyses', context: pohlavi }))}`
        : `${(t('comparison.formattingFunctions.inactiveMember', { ns: 'analyses', context: pohlavi }))}`;
}

export function formatMandateForComparison(
    mandate: number,
    memberData: CouncilMember | null,
    t: TFunction
): string {
    const totalNumOfMandates = memberData ? memberData.dochazka.celkem_zasedani : undefined;

    if (mandate === totalNumOfMandates) {
        return `${(t('comparison.formattingFunctions.wholeTerm', { ns: 'analyses' }))}`;
    }
    return `${t('comparison.formattingFunctions.x-OutOf-y-Meeting', {
                ns: 'analyses',
                x: mandate,
                y: totalNumOfMandates,
                count: totalNumOfMandates
            })
            }`;
}

export function formatPartyForComparison(
    partyData: PolitickaStrana,
    memberData: CouncilMember | null,
    t: TFunction,
    i18n: I18nInstance,
    params: UrlParamsUsedForNavigationType
): ReactElement | string {
    const { municipalitaId = '', bodyType = '', zastupitelstvoId = '' } = params;
    const { id, zkratka, strana_barva } = partyData;

    return (
        <Link to={buildCouncilPath(municipalitaId, bodyType, zastupitelstvoId, 'subjekty', id)} style={{ color: strana_barva }}>
            {zkratka}
        </Link>
    );
}

export function formatVotingAttendanceForComparison(
    value: number,
    _memberData: CouncilMember | null,
    _t: TFunction,
    i18n: I18nInstance,
    _params: UrlParamsUsedForNavigationType
): string {
    return formatPercent(value, i18n.language, 2);
}
